import { render, staticRenderFns } from "./dynamic-deleteAlert.vue?vue&type=template&id=9b25af8a&scoped=true&"
import script from "./dynamic-deleteAlert.vue?vue&type=script&lang=js&"
export * from "./dynamic-deleteAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b25af8a",
  null
  
)

export default component.exports